import React, { ComponentType } from 'react';

import { LegacyIconProps } from '@vk-hr-tek/ui/icons';
import { Icon } from '@vk-hr-tek/ui/Icon';

import { BellNotification } from '@app/gen/bell';

const AdvertisingOutlineIcon = () => (
  <Icon name="advertising_outline" size="20" color="text.light.primary" />
);

export const NOTIFICATIONS_STATUSES = {
  ALL: '0',
  UNREAD: 'unread',
  READ: 'read',
} as const;

export const NOTIFIABLE_NICK_ICONS: Record<
  BellNotification['notifiable_nick'],
  ComponentType<LegacyIconProps>
> = {
  news: AdvertisingOutlineIcon,
  comment: AdvertisingOutlineIcon,
};
